import { curatorStudentsApiSlice } from './curatorStudents'

export type AiMentorKind = 'CHAT' | 'EXPLAIN_TOPIC' | 'EXPLAIN_TEST' | 'PLAN'

export interface AiMentorMessage {
    id: number
    role: 'USER' | 'ASSISTANT'
    kind: AiMentorKind | string
    text: string
    courseTopicId: number | null
    topicTitleKz: string | null
    topicTitleRu: string | null
    // yyyy-MM-ddTHH:mm:ss
    createdAt: string
    citations: unknown[] | null
}

export const AI_MENTOR_PAGE = 30

export const aiMentorHistoryApi = curatorStudentsApiSlice.injectEndpoints({
    endpoints: (build) => ({
        fetchAiMentorHistory: build.query<
            AiMentorMessage[],
            { userCourseEnrollId: number; beforeId?: number }
        >({
            query: ({ userCourseEnrollId, beforeId }) => ({
                url: 'ai-mentor/history',
                params: { userCourseEnrollId, limit: AI_MENTOR_PAGE, ...(beforeId ? { beforeId } : {}) },
            }),
            transformResponse: (response: { data: AiMentorMessage[] }) => response.data ?? [],
        }),
    }),
})
